/**
 * Classe responsável pela funcionalidade do menu
 * para o grid de rota.
 * @author: adalto.junior
 * Date: 08/10/13
 * Time: 22:16
 */


Greenmile.Route = Greenmile.Route || {};

Greenmile.Route.Menu = (function () {

    function Menu () {

        Greenmile.Grid.Menu.apply(this, arguments);

        this.getItemsToMenu = function (modelRoute) {

            var items      = [],
                cloneRoute = null,
                gridMenu   = null,
                route      = null;

            route = new App.Models.Route(modelRoute.attributes);

            if (route) {

                gridMenu = this.gridMenu;

                cloneRoute = {
                    id: 8,
                    description: Monet.I18n.getResourcesByKey('Greenmile.Route.Clone.btnSave'),
                    icon: 'cloneRouteBtn',
                    customClassname: 'CloneRouteItem',
                    action: function () {

                        var completeRoute = new Greenmile.Route.Clone('Route');

                        gridMenu.removeAllMenus();

                        completeRoute.setRoute(route);
                        completeRoute.show();

                    }
                };

                items.push(cloneRoute);
            }

            return items;

        };

    }

    return Menu;

}());